import { UserInfo } from "app/Auth/fetchUserInfo";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type UseUserInfoStoreProps = {
  userInfo: UserInfo | null;
  setUserInfo: (userInfo: UserInfo | null) => void;
  clearUserInfo: () => void;
};

const storageName = "dd-user-info";
const storage = createJSONStorage<UserInfo>(() => localStorage);

/**
 * Holds a global user info state.
 * setUserInfo - Sets the user info of the currently authorized user.
 * clearUserInfo - Reset the state and clear user info from local storage.
 */
export const useUserInfoStore = create<UseUserInfoStoreProps>()(
  persist(
    (set) => ({
      userInfo: null,
      setUserInfo: (userInfo) => set({ userInfo }),
      clearUserInfo: () => set({ userInfo: null }, true), // Clears user info from state and storage
    }),
    {
      name: storageName,
      storage,
    },
  ),
);
